import React from "react";

import {
  RideBottomSheet,
  RideActionableCardSelector,
  RideRadioButton,
} from "@rimac-seguros/ride-system-components";

import "./styles.scss";

export const CustomRadioListBottomSheet = ({
  list = [],
  isOpen,
  setIsOpen,
  name,
  setValue,
  value,
  title,
}) => {
  const handleSelect = (e) => {
    setValue(name, String(e.target?.value));
    setIsOpen(false);
  };

  return (
    <RideBottomSheet
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      className="z-max"
      title={title}
      id="custom-radio-list"
    >
      <div className="custom-radio-list">
        {list.map((option) => {
          const isChecked = String(value) === String(option?.value);
          return (
            <div
              key={option?.value}
              className="border-b border-ride-sys-color-border-default"
            >
              <RideActionableCardSelector
                className="custom-radio-list-card custom-radio-list-no-transform"
                onChange={handleSelect}
                control={
                  <RideRadioButton
                    title={option?.label}
                    name={name}
                    checked={isChecked}
                    value={option?.value}
                    className="custom-radio-list_option"
                    onChange={handleSelect}
                    readOnly
                  />
                }
              >
                <div>
                  <p>{option.label}</p>
                </div>
              </RideActionableCardSelector>
            </div>
          );
        })}
      </div>
    </RideBottomSheet>
  );
};
